import type { ProductVariantDto } from "../../../../api";
import { Image } from "../../../../components/common/image";
import { formatDisplayName } from "../../utils/format-display-name";

interface ProductImageProps {
  currentProduct: ProductVariantDto | null;
  baseProduct: ProductVariantDto;
}

export function ProductImage({
  currentProduct,
  baseProduct,
}: ProductImageProps) {
  // Use selected variant's image if available, otherwise fall back to base product image
  const displayImage = currentProduct?.image || baseProduct?.image;
  const displayName =
    formatDisplayName(currentProduct?.displayName) ||
    currentProduct?.name ||
    formatDisplayName(baseProduct?.displayName) ||
    baseProduct?.name ||
    "Product";

  return (
    <div className="flex-1 flex items-start justify-center rounded-xl p-8 sticky top-6 self-start">
      <div className="w-full max-w-md">
        <Image
          image={displayImage}
          alt={displayName}
          size="w-full h-auto"
          className="max-h-[500px]"
        />
      </div>
    </div>
  );
}
